import moment from "moment";
import { cleanNumber } from "../../../../Utils";

export const formatFieldBirhdate = (
  value: string
): { [key in string]: string } => ({
  birthdate: moment(value, "DD/MM/YYYY").format("YYYY-MM-DD"),
});

export const formatFieldCellphone = (
  value: string
): { [key in string]: string } => {
  const number = cleanNumber(value);
  return {
    area_code: number?.slice(0, 2),
    cell_phone_number: number?.slice(-9),
  };
};
export const formatFieldUsername = (
  value: string
): { [key in string]: string } => {
  const username = value?.replaceAll(" ", "");
  return {
    username,
  };
};

export const formatFieldPassword = (
  value: string
): { [key in string]: string } => {
  const username = value?.replaceAll(" ", "");
  return {
    username,
  };
};
